import { useState, useCallback } from "react";
import { domain, token } from "../../../Security";
import axios from "../../../../api/apiClient";

export const useAmountBasedThreshold = () => {
  const [loading, setLoading] = useState(false);
  const [thresholds, setThresholds] = useState([]);

  // ── Thresholds (Amount Ranges) ──────────────────────────────────────────
  const fetchThresholds = useCallback(async (moduleName) => {
    setLoading(true);
    try {
      const res = await axios.get(`${domain}/api/AmountBasedThreshold/${moduleName}`);
      setThresholds(res.data);
    } catch (err) {
      console.error("Error fetching thresholds", err);
    } finally {
      setLoading(false);
    }
  }, []);

  const saveThreshold = async (payload) => {
    try {
      if (payload.id) {
        await axios.put(`${domain}/api/AmountBasedThreshold/${payload.id}`, payload);
      } else {
        await axios.post(`${domain}/api/AmountBasedThreshold`, payload);
      }
      return { success: true };
    } catch (err) {
      return { success: false, error: err };
    }
  };

  return {
    loading,
    thresholds,
    fetchThresholds,
    saveThreshold,
  };
}